import styled, { css } from 'styled-components';
import {} from './index.js';
import { getMargins, SYS_BREAKPOINT_MD, SYS_SPACE_FIXED_100, SYS_SPACE_FIXED_150 } from '@oneaudi/unified-web-alpha-common';
export const StyledButtonGroupContainer = styled.div `
  margin: ${(props) => getMargins(props.margin)};
  display: flex;
  column-gap: ${SYS_SPACE_FIXED_100};
  row-gap: ${SYS_SPACE_FIXED_150};
  align-items: flex-start;

  ${(props) => {
    if (props.$mode === 'hug') {
        return css `
        flex-wrap: wrap;
        flex-direction: ${props.$orientation === 'vertical' ? 'column' : 'row'};
      `;
    }
    if (props.containsIconButton) {
        return css `
        flex-direction: row;
      `;
    }
    if (props.$orientation === 'vertical') {
        return css `
        flex-direction: column;
      `;
    }
    return css `
      flex-direction: column;

      @media (min-width: ${SYS_BREAKPOINT_MD}) {
        flex-direction: row;
      }
    `;
}}
`;
//# sourceMappingURL=index.styles.js.map